import mixins from "./mixins";
import filters from "./filters";
export default {
  install(Vue) {
    Vue.use(mixins);
    Vue.use(filters);
  },
};
